export const homeObjOne = {
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Love is in the Air...",
  headline: "and so is Spontaneity!",
  description:
    "Use this date idea generator to decide the activity of your next date. Loaded with 50+ ideas.\n Scroll down below to try it!",
  buttonLabel: "",
  imgStart: "",
  img: "./images/couple-date-night.svg",
  alt: "Image goes here.",
  hasLink: false,
  link: "",
};

export const dateIdeas = [
  "go out for bowling 🎳",
  "go out for mini golf ⛳",
  "enjoy an aphrodisiac buffet 😳",
  "try karaoke for two (dramatic duets) 🎙️",
  "have a wine and paint night 🍷🎨",
  "go for a long walk along the beach (and write your initials in the sand)🐚",
  "try out body painting 🎨",
  "go to a cat cafe 😽",
  "visit an art gallery 🖼️",
  "take a salsa dance class 💃🏻",
  "bake a cake together 🎂",
  "rent a couple of sumo wrestler suits 🥊",
  "go for a day trip 🚗",
  "have a beach day 🏖️",
  "go to a puppy pool 🐶",
  "act out scenes from your favorite movies 🎬",
  "go for an outdoor movie date ✨",
  "buy each other a whole new outfit (makeover day) 🛍️",
  "go to the flea market 👓",
  "play a videogame together 🎮",
  "cook a fancy meal together 🍝",
  "go for a hike 🏞️",
  "troll people on the internet together 😂",
  "discover a new restaurant 🍽️",
  "go out for brunch and don't forget the mimosas 🍹",
  "prank call your family and friends 😂",
  "go to a an animal sanctuary 🐯",
  "go to an aquarium 🐠",
  "rent a jetski or two 🌊",
  "attempt to draw portraits of each other ✏️",
  "photograph each other (but like in a romantic and loving way) 📷🥺",
  "dress up in each others outfits 🤔",
  "go out to a sports game 🎾⚽",
  "go to a concert 🎵",
  "stay in, watch TV, order your favorite food and enjoy a cuddlefest 😴🍕",
  "ironically make tiktoks together 😳🎵",
  "go out for a picnic 🏞️",
  "pretend to be your alter egos for a day 😏",
  "build a time capsule 📦",
  "make a splash at the pool 🏊",
  "hit the dance floor 🕺",
  "play a game of 8 ball pool 🎱",
  "draw tattoos all over each other 😏✒️",
  "take a surfing lesson 🏄‍♀️",
  "write a small play together 🎭",
  "solve a 1000 piece puzzle 🧩",
  "compare your zodiac birth charts ♑🔍",
  "play a game of scrabble Ⓜ️",
  "go for an helicopter ride over the city 🚁",
  "go snorkelling or scuba diving 🤿",
  "go camping ⛺",
  "have a spa night 💆",
  "give each other backrubs 💆‍♂️😏",
  "volunteer together 💖",
  "figure out an escape room 🔑",
  "see a comedy show 😂",
  "go to your local botanical garden 🌵",
  "play a few games of chess ♟️",
  "go horseback riding 🐎",
  "go berry or apple picking 🍎",
  "try out bouldering or rock climbing 🧗‍♀️",
  "go to a water park 👙🩳",
  "have a date at an arcade 👾",
  "play laser tag 😎",
  "watch the sunset together 🌇",
  "go to a carinval 🎠",
  "go to a theme park 🎢",
];
